<template>
  <div>
    <div ref="container" class="card-container"></div>
    <div class="button" @click="next()">确定</div>
  </div>
</template>

<script>
import * as THREE from "three";
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls";
const logUrl = require("@/common/logUrl");
const config = require("@/common/config");

export default {
  name: "RotatingCard",
  data() {
    return {
      logUrlList: logUrl.logUrl,
      // 制卡数据
      cardOri: "",
      cardFace: "",
      process: "",
      delImageUrl: "",
      taskId: "",
      phone: "",
      prompt: "",
      bankCode: "",
      // threeD数据
      scene: null,
      camera: null,
      renderer: null,
      card: null,
      controls: null,
      isDragging: false,
      previousMousePosition: {
        x: 0,
        y: 0,
      },
      rotationSpeed: 8 / 1000,
      cardThickness: 50 / 1000, // 卡片厚度
      frontTexture: null, // 正面纹理
      backTexture: null, // 背面纹理
      threeD_width: "",
      threeD_height: "",
      backgroundImage: "",
    };
  },
  created() {
    this.bankSerialNumber = localStorage.getItem("bankSerialNumber");
    this.process = this.$route.params.process;
    this.delImageUrl = this.$route.params.delImageUrl;
    this.taskId = this.$route.params.taskId;
    this.phone = localStorage.getItem("phone");
    this.prompt = this.$route.params.prompt;
    this.bankCode = config.config_demo.bankCode;
    console.log("bankSerialNumber:" + this.bankSerialNumber);
    console.log("bankCode:" + this.bankCode);
    var destImg = this.$route.params.targetImg;
    this.cardFace = destImg;
    console.log("destImg:" + destImg);
    var selectParam = this.$route.params.selectParam;
    console.log("selectParam:" + selectParam);
    if (selectParam !== undefined) {
      this.selectParam = JSON.parse(selectParam);
    }
    this.cardOri = this.$route.params.cardOri;
    console.log("cardOri:" + this.cardOri);
    if (this.cardOri == 0) {
      //横版
      //   this.isHorizontal = true;
      this.threeD_width = 4.6; //长
      this.threeD_height = 3; //宽
      this.backgroundImage = this.logUrlList.threeD_heng;
    } else if (this.cardOri == 1) {
      //竖版
      //   this.isHorizontal = false;
      this.threeD_width = 3; //长
      this.threeD_height = 4.6; //宽
      this.backgroundImage = this.logUrlList.threeD_shu;
    }
  },
  mounted() {
    this.initThree();
    this.animate();
    this.setupEventListeners();
  },
  beforeDestroy() {
    // 清理资源
    if (this.controls) {
      this.controls.dispose();
    }
    if (this.renderer) {
      this.renderer.dispose();
    }
    if (this.scene) {
      while (this.scene.children.length > 0) {
        this.scene.remove(this.scene.children[0]);
      }
    }
  },
  methods: {
    next() {
      var selectParam = JSON.stringify(this.selectParam);
      let cardThemeParam = JSON.stringify(this.cardTheme);
      this.$router.replace({
        name: "UploadCardface_demo",
        params: {
          bankSerialNumber: this.bankSerialNumber,
          bankCode: this.bankCode,
          selectParam: selectParam,
          cardOri: this.cardOri,
          cardTheme: cardThemeParam,
          targetImg: this.cardFace,
          delImageUrl: this.delImageUrl,
          taskId: this.taskId,
          process: this.process,
          phone: this.phone,
          prompt: this.prompt,
        },
      });
    },
    initThree() {
      // 1. 创建场景
      this.scene = new THREE.Scene();

      // 2. 创建相机
      this.camera = new THREE.PerspectiveCamera(
        75,
        this.$refs.container.clientWidth / this.$refs.container.clientHeight,
        0.1,
        1000
      );
      this.camera.position.z = 5;

      // 3. 创建渲染器
      this.renderer = new THREE.WebGLRenderer({ antialias: true });
      this.renderer.setSize(
        this.$refs.container.clientWidth,
        this.$refs.container.clientHeight
      );
      this.renderer.setPixelRatio(window.devicePixelRatio);
      this.$refs.container.appendChild(this.renderer.domElement);
      this.renderer.setClearColor(0xffffff); // 设置背景为白色

      // 4. 创建卡片（有厚度的矩形）
      const width = this.threeD_width;
      const height = this.threeD_height;

      // 加载纹理
      const textureLoader = new THREE.TextureLoader();

      // 加载正面和背面图片
      this.frontTexture = textureLoader.load(this.cardFace); // 替换为你的图片路径
      this.backTexture = textureLoader.load(this.backgroundImage); // 替换为你的图片路径

      // 正面和背面
      const frontGeometry = new THREE.PlaneGeometry(width, height);
      const backGeometry = new THREE.PlaneGeometry(width, height);

      // 侧面几何体（用于创建厚度）
      const sideGeometry = new THREE.BoxGeometry(
        width,
        this.cardThickness,
        height
      );

      // 材质
      const frontMaterial = new THREE.MeshBasicMaterial({
        map: this.frontTexture,
        side: THREE.DoubleSide,
      });
      const backMaterial = new THREE.MeshBasicMaterial({
        map: this.backTexture,
        side: THREE.DoubleSide,
      });
      const sideMaterial = new THREE.MeshBasicMaterial({
        color: 0x3861d5,
        side: THREE.DoubleSide,
      });

      // 创建卡片网格
      this.card = new THREE.Group();

      // 正面
      const frontFace = new THREE.Mesh(frontGeometry, frontMaterial);
      frontFace.position.z = this.cardThickness / 2;
      this.card.add(frontFace);

      // 背面
      const backFace = new THREE.Mesh(backGeometry, backMaterial);
      backFace.position.z = -this.cardThickness / 2;
      this.card.add(backFace);

      // 侧面（上）
      const topSide = new THREE.Mesh(
        new THREE.PlaneGeometry(width, this.cardThickness),
        sideMaterial
      );
      topSide.rotation.x = Math.PI / 2;
      topSide.position.y = height / 2;
      this.card.add(topSide);
      // 侧面（下）
      const bottomSide = new THREE.Mesh(
        new THREE.PlaneGeometry(width, this.cardThickness),
        sideMaterial
      );
      bottomSide.rotation.x = Math.PI / 2;
      bottomSide.position.y = -height / 2;
      this.card.add(bottomSide);
      // 侧面（左）
      const leftSide = new THREE.Mesh(
        new THREE.PlaneGeometry(this.cardThickness, height),
        sideMaterial
      );
      leftSide.rotation.y = Math.PI / 2;
      leftSide.position.x = -width / 2;
      this.card.add(leftSide);
      // 侧面（右）
      const rightSide = new THREE.Mesh(
        new THREE.PlaneGeometry(this.cardThickness, height),
        sideMaterial
      );
      rightSide.rotation.y = Math.PI / 2;
      rightSide.position.x = width / 2;
      this.card.add(rightSide);

      this.scene.add(this.card);

      // 5. 添加轨道控制器（用于鼠标交互）
      this.controls = new OrbitControls(this.camera, this.renderer.domElement);
      this.controls.enableDamping = true; // 添加阻尼效果
      this.controls.dampingFactor = 0.05;
      this.controls.enableZoom = false; // 禁用缩放功能
      this.controls.enablePan = false; // 禁用平移功能（可选）

      // 6. 添加光源（可选）
      const ambientLight = new THREE.AmbientLight(0x404040);
      this.scene.add(ambientLight);

      const directionalLight = new THREE.DirectionalLight(0xffffff, 0.5);
      directionalLight.position.set(1, 1, 1);
      this.scene.add(directionalLight);

      // 7. 窗口大小调整处理
      window.addEventListener("resize", this.onWindowResize);
    },

    animate() {
      requestAnimationFrame(this.animate);

      // 如果用户没有在拖动，卡片自动旋转
      if (!this.isDragging) {
        this.card.rotation.x += this.rotationSpeed;
        this.card.rotation.y += this.rotationSpeed;
      }

      // 更新控制器
      if (this.controls) {
        this.controls.update();
      }

      // 渲染场景
      if (this.renderer && this.scene && this.camera) {
        this.renderer.render(this.scene, this.camera);
      }
    },

    setupEventListeners() {
      const renderer = this.renderer.domElement;

      // 鼠标按下事件
      renderer.addEventListener("mousedown", (event) => {
        this.isDragging = true;
        this.previousMousePosition = {
          x: event.clientX,
          y: event.clientY,
        };
      });

      // 鼠标移动事件
      renderer.addEventListener("mousemove", (event) => {
        if (this.isDragging) {
          const deltaMove = {
            x: event.clientX - this.previousMousePosition.x,
            y: event.clientY - this.previousMousePosition.y,
          };

          // 根据鼠标移动距离旋转卡片
          const deltaRotationQuaternion = new THREE.Quaternion().setFromEuler(
            new THREE.Euler(
              toRadians(deltaMove.y * 0.5),
              toRadians(deltaMove.x * 0.5),
              0,
              "XYZ"
            )
          );

          this.card.quaternion.multiplyQuaternions(
            deltaRotationQuaternion,
            this.card.quaternion
          );

          this.previousMousePosition = {
            x: event.clientX,
            y: event.clientY,
          };
        }
      });

      // 鼠标释放事件
      renderer.addEventListener("mouseup", () => {
        this.isDragging = false;
      });

      // 鼠标离开容器事件
      renderer.addEventListener("mouseleave", () => {
        this.isDragging = false;
      });

      // 触摸事件支持
      renderer.addEventListener(
        "touchstart",
        (event) => {
          this.isDragging = true;
          this.previousMousePosition = {
            x: event.touches[0].clientX,
            y: event.touches[0].clientY,
          };
          event.preventDefault();
        },
        { passive: false }
      );

      renderer.addEventListener(
        "touchmove",
        (event) => {
          if (this.isDragging) {
            const deltaMove = {
              x: event.touches[0].clientX - this.previousMousePosition.x,
              y: event.touches[0].clientY - this.previousMousePosition.y,
            };

            const deltaRotationQuaternion = new THREE.Quaternion().setFromEuler(
              new THREE.Euler(
                toRadians(deltaMove.y * 0.5),
                toRadians(deltaMove.x * 0.5),
                0,
                "XYZ"
              )
            );

            this.card.quaternion.multiplyQuaternions(
              deltaRotationQuaternion,
              this.card.quaternion
            );

            this.previousMousePosition = {
              x: event.touches[0].clientX,
              y: event.touches[0].clientY,
            };
          }
          event.preventDefault();
        },
        { passive: false }
      );

      renderer.addEventListener("touchend", () => {
        this.isDragging = false;
      });

      function toRadians(angle) {
        return angle * (Math.PI / 180);
      }
    },

    onWindowResize() {
      if (this.camera && this.renderer) {
        this.camera.aspect =
          this.$refs.container.clientWidth / this.$refs.container.clientHeight;
        this.camera.updateProjectionMatrix();
        this.renderer.setSize(
          this.$refs.container.clientWidth,
          this.$refs.container.clientHeight
        );
      }
    },
  },
};
</script>

<style scoped>
.card-container {
  width: 100%;
  height: 30rem;
  /* background-color: #000000;  */
  /* overflow: hidden; */
}
.button {
  width: 80%;
  height: 2.8rem;
  margin: 0 10%;
  background-color: #3861d5;
  color: white;
  border-radius: 1.4rem;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/DIYApplyCardSurface/ApplicationCard/CustomLayout/ThreeD.vue